import { useCallback, useState } from 'react';

export interface DialogConfig {
  title?: string;
  content: React.ReactNode;
  primaryButton?: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
  };
  secondaryButton?: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
  };
  showCloseButton?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const useVenereDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState<DialogConfig>({
    content: null,
  });

  const showDialog = useCallback((dialogConfig: DialogConfig) => {
    setConfig(dialogConfig);
    setIsOpen(true);
  }, []);

  const hideDialog = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    config,
    showDialog,
    hideDialog,
  };
}; 